module.exports = __webpack_public_path__ + "static/media/bsa.e2032e92.svg";